import { GridApi } from 'ag-grid-community'
import { useCallback, useEffect, useState } from 'react'
import { useOnMount } from 'view/hooks'

export const useCenterGridPosition = (api: GridApi): [number | undefined, () => void] => {
  const [position, setPosition] = useState<number>()

  const calculatePositionAfterLeftPinnedColumns = useCallback(() => {
    if (api.isDestroyed()) return

    const allColumns = api.getAllDisplayedColumns()
    const pinnedColumns = allColumns.filter(c => c.getPinned() === 'left')
    const [lastPinnedColumn] = pinnedColumns.slice(-1)

    if (lastPinnedColumn) {
      const pinnedLeft = lastPinnedColumn.getLeft()
      const pinnedWidth = lastPinnedColumn.getActualWidth()

      if (pinnedLeft && pinnedWidth) {
        setPosition(Math.round(pinnedLeft + pinnedWidth))
      }
    }
  }, [api])

  useOnMount(() => calculatePositionAfterLeftPinnedColumns())

  useEffect(() => {
    api.addEventListener('componentStateChanged', calculatePositionAfterLeftPinnedColumns)

    return () => {
      api.removeEventListener('componentStateChanged', calculatePositionAfterLeftPinnedColumns)
    }
  }, [api, calculatePositionAfterLeftPinnedColumns])

  return [position, calculatePositionAfterLeftPinnedColumns]
}
